import { environment } from './environment';
import { ConfigManager } from './services/configManager';

export const BROWSER_SESSION_ID_ITEM = 'salesappBrowserSessionId';
export const OMIT_LENDER_REFERENCE_ID = 'RECONSOLIATION_ID';
export const LENDERS_IDS = {
  acima: '62f4cb21f717979a80ad5a95',
  aff: '5f5f6cc4c51bb528b467f55b',
  ally: '60f9645e4a98041f45d64ff5',
  gaf: '60ee91474a98041f45ce9140',
  genesis: '5c584e9d9b389ca0da41ed0e',
  lendingPoint: '61111e56a9f3eccb9361955b',
  milan: '60f57205de47a892d4cab0c4',
  wellsFargo: '614a702f0ddef4d1d67d2b3c',
  coveredCare: '6217b17ef04266e234ebbba2',
  patientFi: '63bfdaae29502ba93e2967e2',
};

export enum AppView {
  StartMainFlow = 'start-page-main-flow',
  StartSelfApplyFlow = 'start-page-self-apply-flow',
  AdvancedCart = 'advanced-cart-page',
  CreateCart = 'create-cart-tab',
  GeneralError = 'general-error',
  Consumers = 'consumers-tab',
  Pending = 'pending-tab',
  Transactions = 'transactions-tab',
  SendLink = 'send-link-modal',
  Processing = 'processing-page',
  ConsumerAccounts = 'consumer-details-modal',
  ThankYou = 'confirm-thank-you-page',
  OrderSummary = 'confirm-order-summary-page',
  ChargeError = 'confirm-error-page',
  UnauthorizedError = 'unauthorized-page',
  NotFound = 'not-found-page',
  StoreSelector = 'store-selector-modal',
  CartItem = 'advanced-cart-item-modal',
  ApplyDisabled = 'apply-disabled-modal',
  CheckoutDisabled = 'checkout-disabled-modal',
  CheckoutLenderDisabled = 'checkout-lender-disabled-modal',
  ConsumerDeviceOnly = 'consumer-device-only-modal',
  Authorization = 'authorization-screen',
  PromotionCodeModal = 'promotion-code-modal',
  SettlementConfiguration = 'settlement-configuration-modal',
  FlipScreen = 'flip-screen',
  IdleTime = 'idle-time-modal',
  DeviceSelectionModal = 'device-selection-modal',
  CartWarningModal = 'cart-warning-modal',
}

export enum FlipOrigin {
  ApplyStart = 'apply-start',
  ApplySuccess = 'apply-success',
  ApplyFailed = 'apply-failed',
  CheckoutStart = 'checkout-start',
  CheckoutFailed = 'checkout-failed',
  ChargeSuccess = 'charge-success',
}
export enum ButtonName {
  StartOver = 'start-over',
  SaveStore = 'save-store',
  SaveItem = 'save-item-advanced-cart',
  RemoveItem = 'remove-advanced-cart',
  DeleteItem = 'delete-item-advanced-cart',
  OpenNewItemAdvanceCart = 'open-new-item-advanced-cart',
  SaveItemToAdvancedCart = 'save-item-advanced-cart',
  StartApply = 'start-apply',
  StartSelfApply = 'start-self-apply',
  StartCheckout = 'start-checkout',
  SendCheckoutLink = 'send-checkout-link',
  SendApplyLink = 'send-apply-link',
  ApplyQrCode = 'apply-qr-code',
  CheckoutQrCode = 'checkout-qr-code',
  ExpressCheckoutQrCode = 'express-qr-code',
  DecreaseQuantity = 'decrease-quantity-advanced-cart',
  IncreaseQuantity = 'increase-quantity-advanced-cart',
  Confirm = 'confirm',
  Logout = 'logout',
  Login = 'login',
  Start = 'start',
  SearchConsumer = 'search-consumer',
  SelectConsumerNavigation = 'select-consumer-navigation',
  SelectConsumer = 'select-consumer',
  ContinuePendingConsumer = 'continue-pending-consumer',
  ContinueFlip = 'continue-from-flip',
  AddItemWarranty = 'add-item-warranty-advanced-cart',
  Close = 'close',
  CloseIdleTimeModal = 'close-idle-time-modal',
  EditStore = 'edit-store',
  ToConsumerDetails = 'to-consumer-details',
  RemoveConsumer = 'remove-consumer',
  EscapeKey = 'exit-modal',
  EditItem = 'edit-item-advanced-cart',
  LinkModalSendLink = 'link-modal-send-link',
  LinkModalNext = 'link-modal-next',
  CloseLinkModal = 'close-link-modal',
  RefreshQrCode = 'refresh-qr-code',
  TryAgain = 'try-again',
  ContinueOnThisDevice = 'continue-on-this-device',
  ContinueOnCustomerDevice = 'continue-on-customer-device',
  UpdateEmail = 'update-email',
}

export const authenticateMerchantConfigPlaceholder: ConfigManager = {
  authOrganizationId: environment.auth0OrganizationId!,
  authClientId: environment.auth0ClientId!,
  peerName: '',
  peerId: '',
  peerPublicKey: '',
  currency: 'USD',
  configuration: {
    settings: {
      idleTimeInMinutes: 45,
      selectedSettleOption: 'Automatic',
      cartType: 'Basic',
    },
    palette: {
      primary: { main: '#426BEC' },
    },
    options: {
      citiExperience: false,
      displayMerchantLogo: true,
      consumerSelfApply: false,
      flipScreen: true,
      merchantOrderIdRequired: true,
      consumersTab: true,
      pendingTab: true,
      transactionsTab: false,
      searchConsumersAcrossAllStores: true,
      showTransactionId: true,
      support: false,
      pin: false,
      description: false,
      interactionOptions: {
        apply: false,
        checkout: false,
        expressCheckout: false,
        applyLink: false,
        checkoutLink: false,
        expressCheckoutLink: false,
        applyQrCode: false,
        checkoutQrCode: false,
        expressCheckoutQrCode: false,
        applySms: false,
        checkoutSms: false,
        expressCheckoutSms: false,
      },
    },
  },
};

export const orderFormDetails: Record<
  'orderId' | 'tax' | 'shipping' | 'discount',
  {
    name: 'merchantOrderId' | 'taxAmount' | 'shippingAmount' | 'discounts';
    validations: Partial<
      Record<
        'length' | 'invalidCharacters' | 'amountExceeding',
        { errorMessage: string; maxLength?: number; regex?: RegExp }
      >
    >;
  }
> = {
  orderId: {
    validations: {
      length: {
        errorMessage: 'Up to 24 characters',
        maxLength: 25,
      },
      invalidCharacters: {
        errorMessage:
          'You may have entered symbols, slashes, or asterisks which are not allowed.',
        regex: /^[a-zA-Z0-9]*$/,
      },
    },
    name: 'merchantOrderId',
  },
  tax: {
    validations: {
      amountExceeding: {
        errorMessage: 'Exceeded cart total',
      },
    },
    name: 'taxAmount',
  },
  shipping: {
    name: 'shippingAmount',
    validations: {
      amountExceeding: {
        errorMessage: 'Exceeded cart total',
      },
    },
  },
  discount: {
    name: 'discounts',
    validations: {
      amountExceeding: {
        errorMessage: 'Exceeded discount amount',
      },
    },
  },
} as const;

export const cartTotalErrorMessage = {
  amountExceeding: 'Cart total exceeding',
  discount: 'Discount exceeds cart total',
  maxAmount: 'Cart total can not exceed',
};

export const SELF_FINANCING_PRODUCT = 'MerchantSelfFinancing';

export const enum ESendLinkModal {
  CustomerInformationTitle = 'Customer information',
  Generate = 'Generate',
  QrCode = 'Qr code',
  ManualLabel = 'Manual',
  AutomaticLabel = 'Automatic',
  SettlePreferenceDescription = 'Please select your preference (required field)',
  SendLinkButton = 'Send',
  Next = 'Next',
  LinkSentMessage = 'Link sent successfully to',
  LinkFailedToSend = 'Unfortunately, the link was not sent to',
  LinkFailedSupport1 = 'Please try again.',
  BackToMainScreen = 'Back to main screen',
  Refresh = 'Refresh',
  Send = 'Send',
  LinkViaEmail = 'Link via email',
  QrCodeFailed = 'Unfortunately, there was an issue generating a QR code.',
  TryAgain = 'Try again',
  UpdateEmail = 'Update Email',
}

export const enum EInternalSettleModal {
  Title = 'Select before checkout',
  Description = 'In the following checkout flow please select if you would like to proceed with auto settle turned on, or manually settle the transaction later through Operate',
  ConfirmButtonText = 'Auto settle',
  CancelButtonText = 'Manual settle',
}

export const START_PAGE_TITLES = {
  mainFlow: 'Buy now pay over time',
  selfApplyFlow: 'Apply for financing TODAY',
};
export const START_PAGE_STEPS = {
  tellAboutYourself: {
    label: 'Tell about yourself',
    content:
      'No long forms. Sign up quickly & easily with a few personal details.',
  },
  selectOffer: {
    mainFlow: {
      label: 'Select an offer',
      content: 'Review and choose financial offers personalized just for you.',
    },
    selfApplyFlow: {
      label: 'Application processed',
      content: 'Your information is sent to multiple providers',
    },
  },
  finializePurchase: {
    mainFlow: {
      label: 'Finalize purchase',
      content: 'Complete payment details at checkout and enjoy your purchase.',
    },
    selfApplyFlow: {
      label: 'Get payment options',
      content: 'Review options you qualify for, and pick the best one!',
    },
  },
};

export enum CONFIRM_PAGE_TITLES {
  'ThankYou' = 'Thank you!',
  'Processing' = 'Processing...',
  'OrderSummary' = 'Order Summary',
  'ChargeError' = 'Oops',
}

export enum CHANGE_PASSWORD_MODAL_TEXTS {
  TITLE = 'Change password',
  CURRENT_PASSWORD = 'Current Password',
  NEW_PASSWORD = 'New Password',
  RE_ENTER_NEW_PASSWORD = 'Re-enter New Password',
  SUBMIT_BUTTON_TEXT = 'Save',
}

export enum NEW_PASSWORD_REQUIREMENTS_LIST_TEXTS {
  TITLE = 'Password must contain:',
  ITEM1 = 'At least 8 characters.',
  ITEM2 = 'Lower case letters (a-z).',
  ITEM3 = 'Upper case letters (A-Z).',
  ITEM4 = 'Numbers (0-9).',
  ITEM5 = 'Special characters (e.g. !@#$%^&*).',
}

export enum DEVICE_SELECTION_MODAL_TEXTS {
  TITLE = 'Checkout',
  CONFIRMATION_BUTTON = 'Continue on this device',
  CANCELLATION_BUTTON = 'Continue on customer’s device',
  CONTENT_CTA = 'Choose an option to proceed.',
  CONTENT_DESCRIPTION1 = 'Checkout with',
  CONTENT_DESCRIPTION2 = 'can only be done on the customer’s device.',
  CONTENT_DESCRIPTION3 = 'You can checkout on this device with',
}

export const CART_WARNING_MODAL_TEXTS = {
  MAX_AMOUNT_TITLE: 'Cart total exceeds maximum',
  MIN_AMOUNT_TITLE: 'Cart amount is below minimum allowed',
  SECONDARY_TITLE: 'Choose an option to proceed',
  CONFIRM_BUTTON: 'Continue',
  CANCEL_BUTTON: 'Adjust Cart',
  INSTRUCTION:
    'Please adjust the cart or choose continue to checkout with a different provider.',
} as const;
